import { throttle } from "lodash";

const LIVE_TIME = "web_live_time";
// 1000 * 60 * 15
// const timeout = 1000 * 15;
const timeout = 900000;
let timer = null;
let substituteSetIdle = null;

// 触发活跃中
function onActive(setIdle) {
  // 清除定时器
  clearTimer();

  // 只要有token，才可以算活跃时间
  if (!localStorage.getItem("token")) {
    // 删除上一次活跃时间
    localStorage.removeItem(LIVE_TIME);
    return;
  }

  // 储存通知组件的回调，后续进入的参数可能不是有效的回调
  if (!substituteSetIdle) {
    substituteSetIdle = setIdle;
  }

  // 更新活跃时间
  localStorage.setItem(LIVE_TIME, new Date().getTime().toString());

  // 重置定时器
  timer = setTimeout(() => {
    // 上一次活跃时间
    const startTime = parseInt(localStorage.getItem(LIVE_TIME) || "0", 10);
    // 当前时间
    const endTime = new Date().getTime();

    // 判断是否空闲
    const idle = endTime - startTime >= timeout;

    if (idle) {
      // 清除定时器
      clearTimer();

      // 删除上一次活跃时间
      localStorage.removeItem(LIVE_TIME);

      // 执行回调，通知组件
      substituteSetIdle(true);

      setTimeout(() => {
        console.table([
          {
            当前空闲状态: idle,
            当前时间: endTime,
            上一次活跃时间: startTime,
            "间隔时间(毫秒)": endTime - startTime,
            "限制时间(毫秒)": timeout,
            是否还有定时器: timer,
          },
        ]);
      });
    }
  }, timeout);
}

function clearTimer() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}

const throttleOnActive = throttle(onActive, 5000);

const EVENT_TYPES = [
  "mousemove", //鼠标移动
  "mousedown", //鼠标按下
  "touchstart", //触摸屏幕（移动端）
  "keydown", //键盘输入
];

//批量添加事件监听
function addEvent() {
  EVENT_TYPES.map((event) => {
    window.addEventListener(event, throttleOnActive);
  });
}

//批量移除事件监听
function removeEvent() {
  EVENT_TYPES.map((event) => {
    window.removeEventListener(event, throttleOnActive);
  });
}

// 取消
function cancel() {
  removeEvent();

  throttleOnActive.cancel();

  substituteSetIdle = null;
}

/**
 * 接收一个回调用于当空闲时间达到阈值后通知组件，
 * 函数内部不操作任何组件，
 * 只操作localStorage[‘live_time’],window的事件绑定/解绑，
 * 仅此而已。
 * 如有额外扩展需自行注释说明。
 */
export default (callback) => {
  // 空闲后通知/清除事件
  function handleIdle(val) {
    cancel();

    callback(val);
  }

  //立刻触发一次活跃中,主要目的是存储回调。
  onActive(handleIdle);
  // 批量添加事件监听
  addEvent();

  // 批量移除事件
  return {
    cancel,
  };
};
